import { createSelector } from '@ngrx/store';
import { getDragonflyCampaignManagementState } from '../reducers/index';

export const getDragonflyCampaignManagement = createSelector(
  getDragonflyCampaignManagementState,
  (state) => state?.search,
);

export const getPanelExpanded = createSelector(getDragonflyCampaignManagement, (state) => state?.panelExpanded);

export const getCampaignName = createSelector(getDragonflyCampaignManagement, (state) => state?.campaignName);

export const getSchemas = createSelector(getDragonflyCampaignManagement, (state) => state?.schemas);

export const getSchemaId = createSelector(getDragonflyCampaignManagement, (state) => state?.schemaId);

export const getSchema = createSelector(getDragonflyCampaignManagement, (state) => state?.schema);

export const getCountries = createSelector(getDragonflyCampaignManagement, (state) => state?.countries);

export const getCountryId = createSelector(getDragonflyCampaignManagement, (state) => state?.countryId);

export const getCountryName = createSelector(getDragonflyCampaignManagement, (state) => state?.countryName);

export const getChannelOptions = createSelector(getDragonflyCampaignManagement, (state) => state?.channelOptions);

export const getChannel = createSelector(getDragonflyCampaignManagement, (state) => state?.channel);

export const getStartDate = createSelector(getDragonflyCampaignManagement, (state) => state?.startDate);

export const getStartDateFormat = createSelector(getDragonflyCampaignManagement, (state) => state?.startDateFormat);

export const getStartDateValidation = createSelector(getStartDate, (startDate) =>
  startDate?.toISOString() !== new Date(0).toISOString() ? startDate : '',
);

export const getEndDate = createSelector(getDragonflyCampaignManagement, (state) => state?.endDate);

export const getEndDateFormat = createSelector(getDragonflyCampaignManagement, (state) => state?.endDateFormat);

export const getEndDateValidation = createSelector(getEndDate, (endDate) =>
  endDate?.toISOString() !== new Date(0).toISOString() ? endDate : '',
);

export const getCampaignEndDateLTStartDate = createSelector(
  getStartDate,
  getEndDate,
  getStartDateFormat,
  getEndDateFormat,
  (campaignStartDate, campaignEndDate, campaignStartDateFormat, campaignEndDateFormat) =>
    campaignStartDateFormat && campaignEndDateFormat ? campaignStartDate > campaignEndDate : false,
);
